(function () {
  'use strict';
  let observer, scrollController, frame;
  function attach() {
    observer?.disconnect();
    scrollController?.abort();
    cancelAnimationFrame(frame);
    document.querySelectorAll('.bfcm-nav a[href^="#"]').forEach(link => {
      link.hidden = !document.getElementById(link.getAttribute('href').slice(1));
    });
    const bar = document.querySelector('[data-bfcm-bar]');
    if (!bar) { document.documentElement.style.removeProperty('--bfcm-bar-height'); return; }
    const trigger = bar.hasAttribute('data-bfcm-landing') ? document.querySelector(bar.dataset.bfcmTrigger || '#stock-up') : null;
    const measure = () => {
      if (bar.hasAttribute('data-bfcm-landing')) {
        // Keep the bar visible below this section; hide it again above the section.
        const visible = Boolean(trigger && trigger.getBoundingClientRect().top < window.innerHeight);
        if (!visible) bar.querySelector('gift-promotion')?.setOpen?.(false);
        bar.hidden = !visible;
      }
      document.documentElement.style.setProperty('--bfcm-bar-height', Math.ceil(bar.getBoundingClientRect().height) + 'px');
    };
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(measure); };
    observer = new ResizeObserver(schedule); observer.observe(bar);
    if (trigger) observer.observe(trigger);
    scrollController = new AbortController();
    for (const event of ['scroll', 'resize', 'pageshow', 'hashchange']) {
      window.addEventListener(event, schedule, { passive: true, signal: scrollController.signal });
    }
    measure();
  }
  attach();
  for (const event of ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder']) document.addEventListener(event, attach);
  // Rule cards share the exact same runtime currency/threshold as the gift controller.
  document.addEventListener('gift-promotion:state', event => {
    const state = event.detail;
    for (const card of document.querySelectorAll('[data-bfcm-gift-rule]')) {
      card.hidden = !state.rule;
      if (!state.rule) continue;
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: state.rule.currency, currencyDisplay: 'narrowSymbol' }).format(state.rule.threshold / 100);
      card.querySelector('[data-bfcm-gift-rule-copy]').textContent = money.replace(/([.,])00$/, '');
    }
  });
})();
